import React from 'react';

export default function Footer() {
    return (
        <div className='w-full py-2 mt-10 border-t-2 border-t-white'>
            <p className='w-full text-center text-white'>
                Random Rates &#169; 2024
            </p>
        </div>
    );
}
